// @flow
import { connect } from 'react-redux'
import _ from 'lodash'
import { patch } from '../../AudienceEditContainer'
import type { Store } from '../../../redux/ducks'
import VkEventGroups from './VkEventGroups'
import type { VkEventGroup, OptionType } from '../../types'
import postJson from '../../../services/postJson'
import { Audience } from '../../constants'
import type { State as AudienceEdit } from '../../../redux/ducks/audienceEdit/reducers'

const EVENT_GROUPS_URL = '/api/v1/audiences_event_retargeting_groups'
const NOT_ALLOWED_WITHOUT_PUBLIC = {
  group_visit: 3,
  group_join: 4,
  group_leave: 5,
  like: 20,
  repost: 21
}

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit
  return {
    vkEventSources: audienceState.vkEventSources,
    vkEventGroups: audienceState.vkEventGroups,
    vkEventOptions: validVkEventOptions(audienceState),
    errors: audienceState.vkEventGroupsErrors
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onChange: (diff: Object) => patch(dispatch, diff),

    onClick: (eventGroup: VkEventGroup, eventGroups: Array<VkEventGroup>) => {
      const diff = { vkEventGroups: _.without(eventGroups, eventGroup) }
      if (eventGroup.id) {
        postJson(`${EVENT_GROUPS_URL}/${eventGroup.id}/delete`).done(() => {
          patch(dispatch, diff)
        })
      } else {
        patch(dispatch, diff)
      }
    }
  }
}

function validVkEventOptions(audienceState: AudienceEdit): Array<OptionType> {
  const { vkEventOptions, vkPlacement } = audienceState
  if (vkPlacement !== Audience.vk_placements.promopost_without_public) return vkEventOptions
  return _.reject(vkEventOptions, (option) => {
    return _.includes(_.keys(NOT_ALLOWED_WITHOUT_PUBLIC), option.name)
  })
}

export function validVkEventGroups(allVkEventGroups: Array<VkEventGroup>): Array<VkEventGroup> {
  return _.reject(allVkEventGroups, (eventGroup) => {
    return !_.isEmpty(_.intersection(eventGroup.eventTypes, _.values(NOT_ALLOWED_WITHOUT_PUBLIC)))
  })
}

const VkEventGroupsContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(VkEventGroups)

export default VkEventGroupsContainer
